// Breakpoint is not available in vuetify breakpoints
// Vuetify doesn't support adding new breakpoints in vuetify.js config(only overriding existing ones)
export const breakpointXsAndDown = () => {
  return window.innerWidth <= 600
}
